import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import { useLocation } from "react-router-dom";
import { useHistory } from "react-router-dom"
import {
  collectNewTargetCountries,
  createCountryOption,
  DEFAULT_TARGET_COUNTRY_OPTIONS,
  fetchTargetCountryOptions,
  getCountryLabels,
  mergeCountryOptions,
  normalizeCountrySelections,
  postNewTargetCountries,
} from "../utils/targetCountry";

const Language = [
  { value: "Danish", label: "Danish" },
  { value: "English", label: "English" },
];

const Format = [
  { value: "A6", label: "A6" },
  { value: "A7", label: "A7" },
];

const AddProduction = () => {
  const history = useHistory()
  const { search } = useLocation();
  const jwtToken = localStorage.getItem("jwt_token");
  const [countrys, setCountrys] = useState([DEFAULT_TARGET_COUNTRY_OPTIONS[0]]);
  const [countryOptions, setCountryOptions] = useState(DEFAULT_TARGET_COUNTRY_OPTIONS);
  const [existingCountryOptions, setExistingCountryOptions] = useState(DEFAULT_TARGET_COUNTRY_OPTIONS);
  const [action, setAction] = useState([]);
  const [select, setSelect] = useState(action[0]);
  const [file, setFile] = useState("");
  const [pdf, setPdf] = useState([]);
  const [fieldDisable, setFieldDisable] = useState(search ? true : false);
  const [langs, setLangs] = useState(Language[0]);
  const [files, setFiles] = useState([]);
  const [displayQrNumber, setDisplayQrNumber] = useState();
  const [formValues, setFormValues] = useState([{ id: 1 }]);
  const [card, setCard] = useState([]);
  const [formats, setFormats] = useState(Format[0]);
  const [errors, setErrors] = useState({});

  const paramIdSeprator = (param) => {
    const paramId = param.split("=");
    return paramId[1];
  };

  const [production, setProduction] = useState({
    batch_no: "",
    qr_no: "",
    prototype_set_id: "",
    year: "",
    month: "",
    count: "",
    remarks: "",
    version: NaN,
    // target_company: Country[0],
    // format: Format[0],
    // language: Language[0],
  });

  const onChangeHandler = (e) => {
    let tempObj = { ...production };
    tempObj[e.target.id] = e.target.value;
    setProduction(tempObj);
  };

  const returnLabel = (arr) => {
    return arr.map((one) => {
      return one.label;
    });
  };

  const loadTargetCountryOptions = async () => {
    const apiCountryOptions = await fetchTargetCountryOptions(jwtToken);
    const mergedOptions = mergeCountryOptions(
      DEFAULT_TARGET_COUNTRY_OPTIONS,
      apiCountryOptions,
    );

    setExistingCountryOptions(mergedOptions);
    setCountryOptions((prev) => mergeCountryOptions(prev, mergedOptions));
  };

  const handleCreateCountry = (inputValue) => {
    const newOption = createCountryOption(inputValue);

    if (!newOption) return;

    setCountryOptions((prev) => mergeCountryOptions(prev, [newOption]));
    setCountrys((prev) => mergeCountryOptions(prev, [newOption]));
  };

  const syncNewTargetCountries = async (selectedCountries) => {
    const newCountries = collectNewTargetCountries(
      [selectedCountries],
      existingCountryOptions,
    );
    const response = await postNewTargetCountries(jwtToken, newCountries);

    if (response?.error) {
      throw new Error(response.error);
    }

    if (newCountries.length) {
      const mergedOptions = mergeCountryOptions(existingCountryOptions, newCountries);
      setExistingCountryOptions(mergedOptions);
      setCountryOptions((prev) => mergeCountryOptions(prev, mergedOptions));
    }
  };

  // const onCountryChange = (e) => {
  //   let tempObj = { ...production };
  //   tempObj['target_company'] = e
  //   setProduction(tempObj);
  // }

  // const onFormatChange = (e) => {
  //   let tempObj = { ...production };
  //   tempObj['format'] = e
  //   setProduction(tempObj);
  // }

  // const onLanguageChange = (e) => {
  //   let tempObj = { ...production };
  //   tempObj['language'] = e
  //   setProduction(tempObj);
  // }

  const autofilldata = (data) => {
    setSelect(data)
    if (data?.ac_content_toc && !search) {
      const array_toc = data.ac_content_toc.split(",")
      const append_toc_data = []
      if (data?.ac_content_toc?.length > 0) {
        for (const id of array_toc) {
          const filteredCard = card.find((e) => {
            return e.value === id
          })
          append_toc_data.push(filteredCard)
        }
      }
      setFormValues(append_toc_data)
    }
  }

  // add-production post api
  const AddProd = () => {
    let url = `${process.env.REACT_APP_API_URL}/add-production`;
    let ValueDaragAndDropOrder = []
    ValueDaragAndDropOrder = dragAndDrop?.updatedOrder.map((item) => item.value)
    const bodyFormData = new FormData();
    bodyFormData.append("batch_no", production.batch_no);
    bodyFormData.append("qr_no", production.qr_no);
    bodyFormData.append("prototype_set_id", select.prototype_no);
    bodyFormData.append("year", production.year);
    bodyFormData.append("month", production.month);
    bodyFormData.append("count", production.count);
    bodyFormData.append("remarks", production.remarks || "");
    bodyFormData.append("target_company", JSON.stringify(getCountryLabels(countrys)));
    bodyFormData.append("format", Array.isArray(formats) ? JSON.stringify(returnLabel(formats)) : JSON.stringify([formats.label]));
    bodyFormData.append(
      "language",
      Array.isArray(langs)
        ? JSON.stringify(returnLabel(langs))
        : JSON.stringify([langs.label])
    )
    bodyFormData.append("ac_content_toc", ValueDaragAndDropOrder.length !== 0 ? dragAndDrop?.updatedOrder.map((item) => item.value) : formValues.map((e) => e.value));
    files.length &&
      Array.from(files).forEach((file) => {
        bodyFormData.append("ac_pdf", file);
      });
    bodyFormData.append("version", production.version);
    fetch(url, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
      body: bodyFormData,
    })
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        if (data.error) {
          toast.error(data.error);
        } else {
          toast.success("Data Added");
          history.push({
            pathname: `/production`,
          })
        }
      });
  };

  const validateForm = () => {
    let isValid = true;
    let newErrors = {};

    const isMissing = (val) => val === "" || val === null || val === undefined;

    if (isMissing(production.batch_no)) {
      newErrors.batch_no = "Batch No is required";
      isValid = false;
    }
    if (isMissing(production.qr_no)) {
      newErrors.qr_no = "QR-gen. no. is required";
      isValid = false;
    }
    if (!select || !select.prototype_no) {
      newErrors.prototype_set_id = "Proto.SetID is required";
      isValid = false;
    }
    if (isMissing(production.count)) {
      newErrors.count = "Count of sets is required";
      isValid = false;
    }
    if (!countrys || countrys.length === 0) {
      newErrors.target_country = "Target Country is required";
      isValid = false;
    }
    if (!formats || (Array.isArray(formats) && formats.length === 0)) {
      newErrors.format = "Format is required";
      isValid = false;
    }
    if (!langs || (Array.isArray(langs) && langs.length === 0)) {
      newErrors.language = "Language is required";
      isValid = false;
    }
    if (isMissing(production.version) || Number.isNaN(production.version)) {
      newErrors.version = "Version is required";
      isValid = false;
    }
    if (isMissing(production.year)) {
      newErrors.year = "Year is required";
      isValid = false;
    }
    if (isMissing(production.month)) {
      newErrors.month = "Month is required";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const onSubmitHandler = (e) => {
    e.preventDefault();
    if (!validateForm()) {
      return;
    }
    if (search) {
      // update api call here
      const id = paramIdSeprator(search);
      let url = `${process.env.REACT_APP_API_URL}/update-production/${id}`;
      const bodyFormData = new FormData();
      let ValueDaragAndDropOrder = []
      ValueDaragAndDropOrder = dragAndDrop?.updatedOrder.map((item) => item.value)
      bodyFormData.append("batch_no", production.batch_no);
      bodyFormData.append("qr_no", production.qr_no);
      bodyFormData.append("prototype_set_id", select.prototype_no);
      bodyFormData.append("count", production.count);
      bodyFormData.append("year", production.year);
      bodyFormData.append("month", production.month);
      bodyFormData.append("remarks", production.remarks || "");
      bodyFormData.append("version", production.version);
      bodyFormData.append("ac_content_toc", ValueDaragAndDropOrder.length !== 0 ? dragAndDrop?.updatedOrder.map((item) => item.value) : formValues.map((e) => e.value));
      bodyFormData.append("target_company", JSON.stringify(getCountryLabels(countrys)));
      bodyFormData.append(
        "format",
        Array.isArray(formats)
          ? JSON.stringify(returnLabel(formats))
          : JSON.stringify([formats.label])
      )
      bodyFormData.append(
        "language",
        Array.isArray(langs)
          ? JSON.stringify(returnLabel(langs))
          : JSON.stringify([langs.label])
      )
      files.length > 0 &&
        Array.from(files).forEach((f) => {
          bodyFormData.append("ac_pdf", f);
        });
      syncNewTargetCountries(countrys)
        .then(() =>
          fetch(url, {
            method: "POST",
            headers: {
              Authorization: `Bearer ${jwtToken}`,
            },
            body: bodyFormData,
          }),
        )
        .then((res) => {
          return res.json();
        })
        .then((data) => {
          if (data.error) {
            toast.error(data.error);
          } else {
            toast.success("Data Updated")
            setFile("")
            history.push({
              pathname: `/production`,
            })
            const fileInput = document.getElementById("formFile");
            if (fileInput) {
              fileInput.value = "";
            }
          }
        })
        .catch((error) => {
          toast.error(error.message || "Unable to save target countries");
        });
    } else {
      syncNewTargetCountries(countrys)
        .then(() => AddProd())
        .catch((error) => {
          toast.error(error.message || "Unable to save target countries");
        });
    }
  };

  const ProductionData = async () => {
    let url = `${process.env.REACT_APP_API_URL}/prototype`;
    const res = await fetch(url, {
      method: "get",
      headers: {
        Authorization: `Bearer ${jwtToken}`,
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        const codeMessage = data.data.prototype_details;
        if (codeMessage) {
          codeMessage.map((one) => {
            (one.value = one.prototype_no), (one.label = one.prototype_no);
          });
          setAction(codeMessage);
          return codeMessage;
        }
      });
    return res;
  };

  const Actioncards = async () => {
    let url = `${process.env.REACT_APP_API_URL}/actioncard`;
    return await fetch(url, {
      method: "get",
      headers: {
        Authorization: `Bearer ${jwtToken}`,
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        const codeMessage = data.data.actioncard_details;
        const optionsList = []
        for (const value of codeMessage) {
          optionsList.push({ value: value.ac_no, label: `${value.ac_no} ${value.english_name}` })
        }
        setCard(optionsList);
        return optionsList;
      });
  };

  //get if search
  const GetDataProd = async (id, dropDownOptions, cardData) => {
    let url = `${process.env.REACT_APP_API_URL}/production/${id}`;
    const res = await fetch(url, {
      method: "get",
      headers: {
        Authorization: `Bearer ${jwtToken}`,
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        const codeMessage = data.data.production;
        const filteredCountry = normalizeCountrySelections(
          codeMessage.target_company,
          countryOptions,
        );
        const filteredFormate = codeMessage.format.flatMap((label) => {
          return Format.filter((one) => one.label === label)
        })
        const filteredLang = codeMessage.language.flatMap((label) => {
          return Language.filter((one) => one.label === label)
        })
        setLangs(filteredLang)
        setCountrys(filteredCountry)
        setFormats(filteredFormate)
        setPdf(codeMessage.version_pdf_file);
        setProduction({
          batch_no: codeMessage.batch_no,
          qr_no: codeMessage.qr_no,
          prototype_set_id: codeMessage.prototype_set_id,
          year: codeMessage.year,
          month: codeMessage.month,
          count: codeMessage.count,
          remarks: codeMessage.remarks,
          version: codeMessage.version,
        });
        const selectedPerson = dropDownOptions.filter((one) => {
          return one.prototype_no === codeMessage.prototype_set_id;
        });

        const array_toc = codeMessage?.ac_content_toc ? codeMessage.ac_content_toc.split(",") : [];
        const smg = [];
        for (const id of array_toc) {
          const filteredCard = cardData.find((e) => {
            return e.value === id
          })
          smg.push(filteredCard)
        }

        setFormValues(smg);

        setSelect(selectedPerson[0]);
      });
    return res;
  };
  //
  useEffect(async () => {
    await loadTargetCountryOptions();
    const actionCards = await Actioncards();
    const id = paramIdSeprator(search);
    await QrNumberInAddData(Boolean(id));
    const dropDownOptions = await ProductionData();
    if (id) {
      GetDataProd(id, dropDownOptions, actionCards);
    }
  }, []);

  const handleFileChange = (event) => {
    const fileList = Array.from(event.target.files);
    const tempList = [...files, ...fileList];
    setFiles(tempList);
  };

  const handleRemove = (index) => {
    const newFiles = [...files];
    newFiles.splice(index, 1);
    setFiles(newFiles);
  };

  const QrNumberInAddData = async (isEditMode) => {
    let url = `${process.env.REACT_APP_API_URL}/qr-number`;
    await fetch(url, {
      method: "get",
      headers: {
        Authorization: `Bearer ${jwtToken}`,
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        const codeMessage = data.data;
        setDisplayQrNumber(codeMessage);
        if (!isEditMode) {
          setProduction((prev) => ({
            ...prev,
            qr_no: codeMessage !== undefined && codeMessage !== null ? String(codeMessage) : "",
          }));
        }
      });
  };

  // <------------------------ Start Drag & Drop ------------------------------->
  const [list, setList] = useState(formValues);

  const handleChange = (i, e) => {
    const newFormValues = [...formValues];
    newFormValues[i] = e;
    setFormValues(newFormValues);
  };

  const addFormFields = () => {
    setFormValues([...formValues, { id: 1 }]);
  };

  const removeFormFields = (i) => {
    const newFormValues = [...formValues];
    if (newFormValues.length > 1) {
      newFormValues.splice(i, 1);
      setFormValues(newFormValues);
    } else {
      setFormValues([{ id: 0 }]);
    }
  };

  const initialDnDState = {
    draggedFrom: null,
    draggedTo: null,
    isDragging: false,
    originalOrder: [],
    updatedOrder: []
  }

  const [dragAndDrop, setDragAndDrop] = useState(initialDnDState);

  const onDragStart = (event) => {
    const initialPosition = Number(event.currentTarget.dataset.position);
    setDragAndDrop({
      ...dragAndDrop,
      draggedFrom: initialPosition,
      isDragging: true,
      originalOrder: list
    });

    event.dataTransfer.setData("text/html", '');
  }

  useEffect(() => {
    setList(formValues)
  }, [formValues])

  const onDragOver = (event) => {
    event.preventDefault();
    let newList = dragAndDrop.originalOrder;
    const draggedFrom = dragAndDrop.draggedFrom;
    const draggedTo = Number(event.currentTarget.dataset.position);
    const itemDragged = newList[draggedFrom];
    const remainingItems = newList.filter((item, index) => index !== draggedFrom);

    newList = [
      ...remainingItems.slice(0, draggedTo),
      itemDragged,
      ...remainingItems.slice(draggedTo)
    ];

    if (draggedTo !== dragAndDrop.draggedTo) {
      setDragAndDrop({
        ...dragAndDrop,
        updatedOrder: newList,
        draggedTo: draggedTo
      })
    }

  }

  const onDrop = (event) => {
    setList(dragAndDrop.updatedOrder);
    setDragAndDrop({
      ...dragAndDrop,
      draggedFrom: null,
      draggedTo: null,
      isDragging: false
    });
  }

  // <------------------------ Stop Drag & Drop ------------------------------->

  return (
    <>
      <h3>{paramIdSeprator(search) ? "Update" : "Add"} Production</h3>
      <form onSubmit={onSubmitHandler}>
        <div className="row">
          {/* Left Side */}
          <div className="col-md-6">
            <label className="mt-1" htmlFor="batch_no">
              Batch No:
            </label>
            <input
              type="number"
              className="form-control"
              id="batch_no"
              value={production.batch_no}
              onChange={onChangeHandler}
              disabled={fieldDisable}
            />
            {errors.batch_no && <div className="text-danger mb-1" style={{ fontSize: "14px" }}>{errors.batch_no}</div>}
            <label className="mt-1" htmlFor="qr_no">
              QR-gen. no.:
            </label>
            <input
              type="text"
              className="form-control"
              id="qr_no"
              value={production.qr_no ?? ""}
              onChange={onChangeHandler}
              disabled={fieldDisable}
            />
            {errors.qr_no && <div className="text-danger mb-1" style={{ fontSize: "14px" }}>{errors.qr_no}</div>}
            <label className="mt-1" htmlFor="inputEmail4">
              Proto.SetID:
            </label>
            <Select
              className="basic-single"
              classNamePrefix="select"
              value={action ? select : []}
              name="color"
              options={action ? action : []}
              onChange={autofilldata}
              isDisabled={fieldDisable}
            />
            {errors.prototype_set_id && <div className="text-danger mb-1" style={{ fontSize: "14px" }}>{errors.prototype_set_id}</div>}
            <label className="mt-1" htmlFor="count">
              Count of sets:
            </label>
            <input
              type="number"
              className="form-control"
              id="count"
              value={production.count}
              onChange={onChangeHandler}
              disabled={fieldDisable}
            />
            {errors.count && <div className="text-danger mb-1" style={{ fontSize: "14px" }}>{errors.count}</div>}
            <label className="mt-1" htmlFor="target_country">
              Target Country:
            </label>
            <CreatableSelect
              id='target_country'
              className="basic-multi-select"
              isMulti
              classNamePrefix="select"
              value={countrys}
              name="color"
              options={countryOptions}
              onChange={(value) => setCountrys(value || [])}
              onCreateOption={handleCreateCountry}
            />
            {errors.target_country && <div className="text-danger mb-1" style={{ fontSize: "14px" }}>{errors.target_country}</div>}
            <label className="mt-1" htmlFor="format">
              Format:
            </label>
            <Select
              id='format'
              className="basic-multi-select"
              isMulti
              classNamePrefix="select"
              value={Format ? formats : []}
              name="color"
              options={Format}
              onChange={setFormats}
            />
            {errors.format && <div className="text-danger mb-1" style={{ fontSize: "14px" }}>{errors.format}</div>}
            <label className="mt-1" htmlFor="language">
              Language:
            </label>
            <Select
              id='language'
              className="basic-multi-select"
              isMulti
              classNamePrefix="select"
              value={Language ? langs : []}
              name="color"
              options={Language}
              onChange={setLangs}
            />
            {errors.language && <div className="text-danger mb-1" style={{ fontSize: "14px" }}>{errors.language}</div>}
          </div>

          {/* Right Side */}
          <div className="col-md-6">
            <label className="mt-1" htmlFor="version">
              version:
            </label>
            <input
              type="number"
              className="form-control"
              id="version"
              value={production.version}
              onChange={onChangeHandler}
              disabled={fieldDisable}
            />
            {errors.version && <div className="text-danger mb-1" style={{ fontSize: "14px" }}>{errors.version}</div>}
            <label className="mt-1" htmlFor="year">
              Year:
            </label>
            <input
              type="number"
              className="form-control"
              id="year"
              value={production.year}
              onChange={onChangeHandler}
              disabled={fieldDisable}
            />
            {errors.year && <div className="text-danger mb-1" style={{ fontSize: "14px" }}>{errors.year}</div>}
              <label className="mt-1" htmlFor="month">
              Month:
            </label>
            <input
              type="number"
              className="form-control"
              id="month"
              value={production.month}
              onChange={onChangeHandler}
              disabled={fieldDisable}
            />
            {errors.month && <div className="text-danger mb-1" style={{ fontSize: "14px" }}>{errors.month}</div>}
            {paramIdSeprator(search)
              ? pdf.map((e) => (
                <label>
                  version :{e.version}, pdf:{e.ac_pdf}
                </label>
              ))
              : null}
            <br></br>
            <label className="mt-1" htmlFor="formFile">
              AC-document:
            </label>
            <div>
              <input
                type="file"
                id="formFile"
                multiple
                onChange={handleFileChange}
                className="form-control"
                disabled={fieldDisable}
              />
              {files.length ? (
                <div className="border mt-3 d-flex flex-wrap">
                  {files.map((file, index) => (
                    <div className="ml-3 mr-5 my-1">
                      <div
                        className="border p-1 bg-muted rounded"
                        style={{ backgroundColor: "#e6e6e6" }}
                      >
                        {file.name}{" "}
                        <button
                          type="button"
                          className="btn-sm p-0 px-1 m-1 border-0"
                          style={{ backgroundColor: "#e6e6e6" }}
                          onClick={() => handleRemove(index)}
                        >
                          <b>X</b>
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              ) : null}
            </div>

            <label className="mt-1" htmlFor="remarks">
              Remarks:
            </label>
            <textarea
              type="text"
              className="form-control"
              id="remarks"
              value={production.remarks}
              onChange={onChangeHandler}
              disabled={fieldDisable}
            />
            <button
              type="Submit"
              className="btn m-3 bg_color"
              disabled={fieldDisable}
            >
              Print
            </button>
            <button
              type="button"
              className="btn m-3 bg_color"
              disabled={!fieldDisable}
              onClick={(e) => {
                setFieldDisable(false);
              }}
            >
              Unlock
            </button>
          </div>
        </div>
      </form >

      {/* <------------------------ Start Drag & Drop -------------------------------> */}
      <div className="mt-3">
        <section>
          <ul>
            {list.map((element, index) => {
              return (
                <li
                  key={index}
                  data-position={index}
                  draggable
                  onDragStart={onDragStart}
                  onDragOver={onDragOver}
                  onDrop={onDrop}
                  className={dragAndDrop && dragAndDrop.draggedTo === Number(index) ? "dropArea" : ""}
                >
                  <div style={{ width: "50%" }}>
                    <div class="container">
                      <div>
                        <div key={index}>
                          <div className="row">
                            <div className="col-md-11 mb-3">
                              <Select
                                value={element}
                                onChange={(e) => handleChange(index, e)}
                                options={card}
                              >
                              </Select>
                            </div>
                            <div className="col-md-1">
                              <button
                                type="button"
                                className="btn btn-danger"
                                style={{ height: "36px" }}
                                onClick={() => removeFormFields(index)}
                              >
                                -
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              )
            })}
          </ul>
          <button
            type="button"
            className="btn btn-primary"
            onClick={addFormFields}
          >
            +
          </button>
        </section>
      </div>
      {/* // <------------------------ Stop Drag & Drop -------------------------------> */}
    </>
  );
};

export default AddProduction;
